import { defineResource } from '@tnn/core'
import { z } from 'zod'

export const productStatuses = ['active', 'inactive'] as const

/** What customers send, with the unit and price per piece a new waybill line starts from */
export const product = defineResource({
  app: 'tms',
  name: 'product',
  path: 'products',
  schema: z.object({
    name: z.string().trim().min(1).max(200),
    unit: z.string().trim().max(30).nullish(),
    rate: z.number().min(0).default(0),
    weightKg: z.number().min(0).nullish(),
    status: z.enum(productStatuses).default('active'),
    notes: z.string().max(1000).nullish(),
  }),
  fields: {
    name: { search: true, list: { priority: 1 }, form: { span: 6 }, import: { aliases: ['สินค้า', 'ชื่อสินค้า'] } },
    unit: { suggest: true, list: { width: 120, priority: 1 }, form: { span: 3 }, import: { aliases: ['หน่วย'] } },
    rate: { type: 'money', list: { align: 'end', width: 140, priority: 1 }, form: { span: 3 }, import: { aliases: ['อัตรา', 'ราคา'] } },
    weightKg: { list: { align: 'end', width: 140, priority: 2 }, form: { span: 3 } },
    status: { filter: true, tones: { active: 'success', inactive: 'neutral' }, list: { width: 120, priority: 1 }, form: { span: 3 } },
    notes: { type: 'textarea', form: { span: 12 } },
  },
  title: 'name',
  defaultSort: 'name',
  importKey: 'name',
  card: { title: 'name', subtitle: 'unit', meta: ['rate'], status: 'status' },
})
